import axios from "axios";
import queryString from "query-string";
import { NOT_DASHBOARD_ROUTES } from "../commons/enum";
import { getCurrentPath } from "../utils";
import { isBrowser } from "../utils/miscellaneous-util";

export const getHostName = () => {
  if (process.env.GATSBY_APP_HOST) {
    return process.env.GATSBY_APP_HOST;
  }
  if (isBrowser()) {
    const { hostname } = window.location;
    const splittedHostname = hostname.split(".");
    if (splittedHostname.includes("staging")) {
      const index = splittedHostname.lastIndexOf("staging");
      return splittedHostname.slice(index).join(".");
    }
    if (splittedHostname.includes("app")) {
      const index = splittedHostname.lastIndexOf("app");
      return splittedHostname.slice(index + 1).join(".");
    }
    if (splittedHostname.includes("backoffice")) {
      const index = splittedHostname.lastIndexOf("backoffice");
      return splittedHostname.slice(index + 1).join(".");
    }
    return window.location.hostname;
  }
  return "";
};

const isDevelopmentEnv =
  process.env.ACTIVE_ENV === "development" || process.env.NODE_ENV === "development";

export const checkIsPrivateRoute = () => {
  const pathname = getCurrentPath();
  // eslint-disable-next-line no-restricted-syntax
  for (const route of NOT_DASHBOARD_ROUTES) {
    if (pathname.indexOf(route) >= 0) {
      return false;
    }
  }
  return true;
};

export const getAppAPIUrl = () => {
  if (process.env.GATSBY_APP_HOST) {
    // In development, use local proxy to avoid third-party cookie blocking
    if (isDevelopmentEnv) {
      return "/api";
    }
    return `https://api.${process.env.GATSBY_APP_HOST}/api`;
  }
  const URL = `${isDevelopmentEnv ? "http" : "https"}://api.${getHostName()}${
    isDevelopmentEnv ? ":3000" : ""
  }/api`;
  return URL;
};
const axiosClient = axios.create({
  baseURL: getAppAPIUrl(),
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  withCredentials: true,
  paramsSerializer: (params) => queryString.stringify(params),
});

axiosClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  const { method } = config;
  if (method !== "get") {
    axiosClient.defaults.headers.common["csrf-token"] = token;
  }
  return config;
});

axiosClient.interceptors.response.use(
  (response) => {
    return response?.data;
  },
  (error) => {
    const status = error?.response?.status;
    const companyStatus = error?.response?.data?.companyStatus;
    const message = error?.response?.data?.message;
    if (status === 403 && message === "Company is not approved for access") {
      const currentPath = window.location.pathname;
      if (companyStatus === "AWAITING_APPROVAL") {
        if (!currentPath.startsWith("/waiting-for-approval")) {
          window.location.href = "/waiting-for-approval";
        }
      } else if (companyStatus === "DEACTIVATED" || companyStatus === "PAYMENT_OVERDUE") {
        if (!currentPath.startsWith("/forbidden")) {
          window.location.href = `/forbidden?companyStatus=${companyStatus}`;
        }
      } else if (!currentPath.startsWith("/forbidden")) {
        window.location.href = "/forbidden";
      }
    }
    return Promise.reject(error);
  }
);

export default axiosClient;
